export function formatCourseDurationLabel(value) {
  if (value == null) return '0s';

  const raw = String(value).trim();
  if (!raw) return '0s';

  if (/^\d+:\d{2}:\d{2}$/.test(raw)) {
    const [hours, minutes, seconds] = raw.split(':').map(Number);
    const parts = [];
    if (hours) parts.push(`${hours}h`);
    if (minutes) parts.push(`${minutes}m`);
    if (seconds || parts.length === 0) parts.push(`${seconds}s`);
    return parts.join(' ');
  }

  if (/^\d+:\d{2}$/.test(raw)) {
    const [minutes, seconds] = raw.split(':').map(Number);
    const parts = [];
    if (minutes) parts.push(`${minutes}m`);
    if (seconds || parts.length === 0) parts.push(`${seconds}s`);
    return parts.join(' ');
  }

  if (/^\d+$/.test(raw)) {
    const totalSeconds = Number(raw);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const parts = [];
    if (hours) parts.push(`${hours}h`);
    if (minutes) parts.push(`${minutes}m`);
    if (seconds || parts.length === 0) parts.push(`${seconds}s`);
    return parts.join(' ');
  }

  return raw;
}

export default formatCourseDurationLabel;
